import { HALF_HOUR_STEP_MINUTES } from '../config/schedule-session.config';

const MINUTES_PER_DAY = 24 * 60;

export type NextHalfHour = {
    minutes: number;
    // 1 when the next half-hour mark rolls past midnight — the caller must advance the date too.
    dayOffset: 0 | 1;
};

// Exactly on a half-hour mark rolls forward to the next one, rather than returning `now` itself.
export function getNextHalfHour(now: Date): NextHalfHour {
    const minutesSinceMidnight = now.getHours() * 60 + now.getMinutes();
    const stepsElapsed = Math.floor(minutesSinceMidnight / HALF_HOUR_STEP_MINUTES) + 1;
    const totalMinutes = stepsElapsed * HALF_HOUR_STEP_MINUTES;

    return totalMinutes >= MINUTES_PER_DAY
        ? { minutes: totalMinutes - MINUTES_PER_DAY, dayOffset: 1 }
        : { minutes: totalMinutes, dayOffset: 0 };
}
